<template>
  <div id="cyclic-definition_info">
      <v-container>
        <v-layout row wrap >
         <v-flex xs6 offset-xs3>
          <v-data-table
                    :headers="headers"
                    :items="teams"
                    hide-actions
                    class="elevation-1"
                  >
                    <template slot="items" slot-scope="props">
                      <td>{{ props.item.name }}</td>
                    </template>
                    <template slot="no-data">
                    </template>
                  </v-data-table>
        </v-flex>
      </v-layout>
  </v-container>
  </div>
</template>

<script>

export default {
  components: {
  },
  props:["teams"],
  data() {
    return {
      headers: [
        { text: 'Team', value: 'name' },
      ],
    }
  },
  computed: {
  },
  created() {
  },
  methods: {},
}
</script>

<style>

</style>
